import { JobProps } from 'common/types'
import { createJobSlug } from 'common/utils/createJobSlug'
import { useAnalytics, AnalyticUserType } from 'hooks/use-analytics/useAnalytics'
import useApplyJob from 'hooks/use-apply-job/useApplyJob'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

export const useMiniJobCard = (job: JobProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alreadyApplied, setAlreadyApplied] = useState<boolean>(false)
  const { backendPartner, backendUser, setForwardingUrl } = useAuth()
  const { logEventAnalytics,handleTracker } = useAnalytics()
  const { notify } = useNotification()
  const history = useHistory()
  const { isDevice } = useScreenSizes()
  const { getJobStatus } = useApplyJob()

  const checkForExistingApplication = async () => {
    const response = await getJobStatus(job?.id)
    if (response?.appliedDate) {
      setAlreadyApplied(true)
    }
    return
  }

  const toggleModal = () => {
    setIsModalOpen(state => !state)
  }

  const handleJobApply = async() => {
    if(job?.jobUrl){
      ((job.jobUrl?.includes('http://')) || (job.jobUrl?.includes('https://'))) ? null : job.jobUrl = 'http://' + job.jobUrl
      window.open(job?.jobUrl, '_blank')
      return
    }
    if (job.isApplyDisabled === true) {
      setShowAlert(preValue => !preValue)
      setIsModalOpen(false)
    } else {
      if (isDevice) {
      backendUser ? history.push(`/member/jobs/apply-job/${job?.id}`) : history.push('/')
      setForwardingUrl(`/member/jobs/apply-job/${job?.id}`)
    }
    backendUser ? setIsModalOpen(true) : history.push('/')
    setForwardingUrl(`/jobs/details/${job?.id}`)
    const logData = {
      'User ID': backendUser?.id,
      'Email address': backendUser?.username,
      'Partner ID': backendPartner?.id,
      'Company Name': backendPartner?.name,
      'Job ID': job?.id,
      'Job Name': job?.title,
      'Job Company': job?.companyName,
      'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role
    }  
    await handleTracker(AnalyticUserType.MEMBER, 'Job apply link clicked', logData, 'mixpanel', null, backendUser)
  }
}

  const handleCopyClipBoard = () => {
    navigator.clipboard.writeText(`https://${window.location.host}/job/${createJobSlug(job?.id, job?.title)}`)
    const partnerLog = {}
    const userLog = {}

    if (backendUser?.partnerId) {
      partnerLog['Partner ID'] = backendUser?.partnerId
      partnerLog['Company Name'] = backendPartner?.name
    }

    logEventAnalytics(
      backendUser?.partnerId ? 'Partner' : backendUser?.role,
      'Copy link to job',
      'mixpanel',
      'Copy link to job',
      {
        'Job ID': job?.id,
        'Job Name': job?.title,
        'User ID': backendUser?.id,
        'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role,
        ...userLog,
        ...partnerLog
      },
      backendUser?.id,
      {
        $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
        $email: backendUser?.username
      }
    )
    notify('success', 'Link copied to clipboard')
  }

  const handleJobApplySuccess = async () => {
    setAlreadyApplied(true)
    const logData = {
      'User ID': backendUser?.id,
      'Email address': backendUser?.username,
      'Partner ID': backendPartner?.id,
      'Company Name': backendPartner?.name,
      'Job ID': job?.id,
      'Job Name': job?.title,
      'Job Company': job?.companyName,
      'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role
    }
    await handleTracker(AnalyticUserType.MEMBER, 'Job applied', logData, 'mixpanel', null, backendUser)
  }

  useEffect(() => {
    checkForExistingApplication()
  }, [])

  return {
    isModalOpen,
    setIsModalOpen,
    alreadyApplied,
    backendPartner,
    backendUser,
    logEventAnalytics,
    history,
    toggleModal,
    handleJobApply,
    handleCopyClipBoard,
    handleJobApplySuccess,
    showAlert
  }
}
